import React, { useState, useEffect, createContext, useRef } from "react";
import * as api from "../../api/api";
// import OptionBarServiceButton from "../Components/OptionBarServiceButton";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";
import { BiSearch } from "react-icons/bi";
import { BsPersonFillGear } from "react-icons/bs";
import { Snackbar, Alert } from "@mui/material";

import InputGroup from "react-bootstrap/InputGroup";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  useNavigate,
  useLocation,
  NavLink,
  Outlet,
} from "react-router-dom";
import Loading from "../../Components/Loading";
import Form from "react-bootstrap/Form";
import RenderFormList from "../../Components/RenderFormList";
import RenderNestedServicesWithForms from "../../Components/RenderNestedServicesWithForms";
import FormsView from "../../Components/Agent/FormsView";
import RenderAgentNestedServices from "../../Components/Agent/RenderAgentNestedServices";
import YesNoModal from "../../Components/Modal/YesNoModal";
import { MemoryFieldProvider } from "../../Components/Agent/MemoryFieldProvider";

export const AgentContext = createContext(null);
export const FormsResponseContext = createContext(null);
function AgentFormsAndServices(props) {
  const { language } = useLanguage();
  const pageTitle = "AgentFormsAndServices";
  const [formsResponse, setFormsResponse] = useState(null);
  //   const [formCreationData, setformCreationData] = useState(formTemplate);
  const [validated, setValidated] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [processIsCreated, setProcessIsCreated] = useState(false);
  const [snackbarData, setSnackbarData] = useState({ show: false });
  const [isLaunchingProcess, setIsLaunchingProcess] = useState(false);
  const [showModal, setShowModal] = useState({
    show: false,
    current: "",
    service: "",
    form: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("id is : ", params.id);
    console.log("retrieving service in admin services");
    console.log("fetching services");

    handleFetchServices();
  }, []);

  const handleFetchServices = () => {
    setLoading(true);
    api.getAllAgentServices().then((response) => {
      setLoading(false);
      console.log(response.data.object);
      setFormsResponse(response.data.object);
    });
  };

  // const handleStartForm = (service, form) => {
  //   console.log("service is ", service);
  //   console.log("form is", form);
  //   api
  //     .insertProcess({
  //       serviceId: service.serviceId,
  //       formId: form.formId,
  //       status: "start",
  //     })
  //     .then(() => {
  //       console.log("done");
  //       setProcessIsCreated(!processIsCreated);
  //     });
  // };
  function formatDateToUTCString(date) {
    return (
      date.getUTCFullYear() +
      "-" +
      String(date.getUTCMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getUTCDate()).padStart(2, "0") +
      " " +
      String(date.getUTCHours()).padStart(2, "0") +
      ":" +
      String(date.getUTCMinutes()).padStart(2, "0") +
      ":" +
      String(date.getUTCSeconds()).padStart(2, "0")
    );
  }
  function getStartAndEndUTC() {
    const now = new Date();
    const startOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        0,
        0,
        0
      )
    );
    const endOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        23,
        59,
        59
      )
    );

    return {
      startDate: formatDateToUTCString(startOfDay),
      endDate: formatDateToUTCString(endOfDay),
    };
  }
  const handleModalStartForm = () => {
    let currentProcess = showModal.current;
    let service = showModal.service;
    let form = showModal.form;
    api
      .endProcess(
        currentProcess.processId,
        false,
        currentProcess.allProcessDetails
      )
      .then(() => {
        api
          .insertProcess({
            serviceId: service.serviceId,
            formId: form.formId,
            processTypeName: "OFFLINE_ACTIVITY",
          })
          .then(() => {
            console.log("done");
            setProcessIsCreated(!processIsCreated);
            setShowModal({ show: false, current: "", service: "", form: "" });
          });
      });
  };
  const hasRunOnceRef = useRef(false);
  let isStartingForm = false;
  const handleStartForm = (service, form) => {
    if (!isStartingForm) {
      isStartingForm = true;
      console.log("service is ", service);
      console.log("form is", form);
      const { startDate, endDate } = getStartAndEndUTC();
      console.log(startDate);
      console.log(endDate);
      api.getAllProcesss(startDate, endDate).then((response) => {
        const { current, history } = response.data.object;
        if (current && current.length > 0) {
          let currentProcess = current[0];
          if (
            currentProcess.processType.name === "Incoming Call" ||
            currentProcess.processType.name === "Outgoing Call"
          ) {
            console.warn("handle start form function is the one talking: ");

            //show error message
            setSnackbarData({
              ...snackbarData,
              show: true,
              severity: "error",
            });
          } else if (
            (currentProcess.form.formId !== form.formId &&
              currentProcess.service.serviceId !== service.serviceId) ||
            (currentProcess.form.formId !== form.formId &&
              currentProcess.service.serviceId == service.serviceId)
          ) {
            setShowModal({
              show: true,
              current: currentProcess,
              service: service,
              form: form,
            });
          }
        } else {
          api
            .insertProcess({
              serviceId: service.serviceId,
              formId: form.formId,
              processTypeName: "OFFLINE_ACTIVITY",
            })
            .then(() => {
              console.log("done");
              setProcessIsCreated(!processIsCreated);
              isStartingForm = false;
            })
            .finally(() => {
              isStartingForm = false;
            });
        }
      });
    }
  };
  return (
    <AgentContext.Provider
      value={(service, form) => handleStartForm(service, form)}
    >
      <div className="main-content-container">
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarData.show}
          autoHideDuration={3000}
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          <Alert
            severity="error"
            onClose={() => setSnackbarData({ ...snackbarData, show: false })}
          >
            {strings[pageTitle][language].CantStartForm}
          </Alert>
        </Snackbar>
        <YesNoModal
          YesText={strings[pageTitle][language].Yes}
          NoText={strings[pageTitle][language].No}
          propShow={showModal.show}
          handleYes={handleModalStartForm}
          handleShowModal={(showValue) =>
            setShowModal({
              show: showValue,
              current: "",
              service: "",
              form: "",
            })
          }
        >
          {strings[pageTitle][language].ChangeFormMessage}
        </YesNoModal>
        <div className="options-bar" style={{ width: "23%" }}>
          <h5 className="options-bar__title">SERVICES</h5>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="options-bar__list">
              {/* <FormsList services =  {serviceList} / > */}
              {/* <RenderNestedOptions options={servicesExample} /> */}
              {/* <OptionBarFormButton option={myform} /> */}
              <RenderAgentNestedServices
                options={formsResponse}
                icon={<BsPersonFillGear size={20} />}
                customPath={"/agent/form"}
              />
            </div>
          )}
        </div>
        {/* <Outlet /> */}
        {formsResponse !== null && (
          <FormsResponseContext.Provider value={formsResponse}>
            <MemoryFieldProvider>
              <FormsView processIsCreated={processIsCreated} />
            </MemoryFieldProvider>
          </FormsResponseContext.Provider>
        )}
      </div>
    </AgentContext.Provider>
  );
}

export default AgentFormsAndServices;
